<div class="p-4">
  <div class="text-center mb-4 bg-purple-600 text-white p-4 rounded-lg">
    <div>
      <p class="font-bold text-lg">You're a PRO</p>
      <p>We appreciate your support!</p>
    </div>
  </div>

  <p class="mb-4 text-gray-500">
    Prefund is a solo venture developed and maintained by a single developer. By
    being subscribed to Prefund Pro you help covering the server costs and you
    motivate the developer to keep working on the product. Thank you!
  </p>

  <span
    (click)="isLoading ? '' : redirect()"
    class="mb-4 block cursor-pointer mb-2 hover:underline {{
      isLoading ? 'text-gray-500' : 'text-blue-500'
    }}"
  >
    {{ isLoading ? "Redirecting..." : "Manage subscription on Stripe" }}
  </span>
</div>
